"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _default = {
  "vico-equense": {
    "7bf2cb81": [{
      "hkey": "af3a8fed",
      "slug": "vico-equense",
      "name": "Vico Equense",
      "primary": true,
      "skipSearch": false
    }],
    "alberi": [{
      "hkey": "af3a8fed",
      "slug": "vico-equense",
      "name": "Vico Equense",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 9,
      "slugLevelParent": null
    }],
    "5fb6d57d": [{
      "hkey": "972bdc7e",
      "slug": "arola-preazzano",
      "name": "Arola-Preazzano",
      "primary": true,
      "skipSearch": false
    }],
    "arola": [{
      "hkey": "972bdc7e",
      "slug": "arola-preazzano",
      "name": "Arola-Preazzano",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 10,
      "slugLevelParent": null
    }],
    "2fff2b7b": [{
      "hkey": "af3a8fed",
      "slug": "vico-equense",
      "name": "Vico Equense",
      "primary": true,
      "skipSearch": false
    }],
    "bonea": [{
      "hkey": "af3a8fed",
      "slug": "vico-equense",
      "name": "Vico Equense",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 9,
      "slugLevelParent": null
    }],
    "fb99b356": [{
      "hkey": "af3a8fed",
      "slug": "vico-equense",
      "name": "Vico Equense",
      "primary": true,
      "skipSearch": false
    }],
    "massaquano": [{
      "hkey": "af3a8fed",
      "slug": "vico-equense",
      "name": "Vico Equense",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 9,
      "slugLevelParent": null
    }],
    "fb3e33b6": [{
      "hkey": "c5c999a2",
      "slug": "villaggio-monte-faito",
      "name": "Villaggio Monte Faito",
      "primary": true,
      "skipSearch": false
    }],
    "monte-faito": [{
      "hkey": "c5c999a2",
      "slug": "villaggio-monte-faito",
      "name": "Villaggio Monte Faito",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 10,
      "slugLevelParent": null
    }],
    "a7c19951": [{
      "hkey": "e8e6a89e",
      "slug": "montechiaro",
      "name": "Montechiaro",
      "primary": true,
      "skipSearch": false
    }],
    "montechiaro-fornacelle": [{
      "hkey": "e8e6a89e",
      "slug": "montechiaro",
      "name": "Montechiaro",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 10,
      "slugLevelParent": null
    }],
    "a6281e1f": [{
      "hkey": "af3a8fed",
      "slug": "vico-equense",
      "name": "Vico Equense",
      "primary": true,
      "skipSearch": false
    }],
    "pacognano": [{
      "hkey": "af3a8fed",
      "slug": "vico-equense",
      "name": "Vico Equense",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 9,
      "slugLevelParent": null
    }],
    "9418a79d": [{
      "hkey": "af3a8fed",
      "slug": "vico-equense",
      "name": "Vico Equense",
      "primary": true,
      "skipSearch": false
    }],
    "pietrapiana": [{
      "hkey": "af3a8fed",
      "slug": "vico-equense",
      "name": "Vico Equense",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 9,
      "slugLevelParent": null
    }],
    "34f994a9": [{
      "hkey": "972bdc7e",
      "slug": "arola-preazzano",
      "name": "Arola-Preazzano",
      "primary": true,
      "skipSearch": false
    }],
    "prezzano": [{
      "hkey": "972bdc7e",
      "slug": "arola-preazzano",
      "name": "Arola-Preazzano",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 10,
      "slugLevelParent": "vico-equense"
    }],
    "2d88d7b4": [{
      "hkey": "af3a8fed",
      "slug": "vico-equense",
      "name": "Vico Equense",
      "primary": true,
      "skipSearch": false
    }],
    "san-salvatore": [{
      "hkey": "af3a8fed",
      "slug": "vico-equense",
      "name": "Vico Equense",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 9,
      "slugLevelParent": null
    }],
    "b527818b": [{
      "hkey": "af3a8fed",
      "slug": "vico-equense",
      "name": "Vico Equense",
      "primary": true,
      "skipSearch": false
    }],
    "sant-andrea": [{
      "hkey": "af3a8fed",
      "slug": "vico-equense",
      "name": "Vico Equense",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 9,
      "slugLevelParent": null
    }],
    "8b0ed37d": [{
      "hkey": "47a82349",
      "slug": "vico-equense",
      "name": "Vico Equense",
      "primary": true,
      "skipSearch": false
    }],
    "seiano": [{
      "hkey": "47a82349",
      "slug": "vico-equense",
      "name": "Vico Equense",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 10,
      "slugLevelParent": "vico-equense"
    }],
    "2b76b048": [{
      "hkey": "47a82349",
      "slug": "vico-equense",
      "name": "Vico Equense",
      "primary": true,
      "skipSearch": false
    }],
    "vico-equense-capoluogo": [{
      "hkey": "47a82349",
      "slug": "vico-equense",
      "name": "Vico Equense",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 10,
      "slugLevelParent": null
    }]
  }
};
exports["default"] = _default;